import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path
      d="M20,7C12.83,7,7,12.83,7,20s5.83,13,13,13s13-5.83,13-13S27.17,7,20,7z M30.95,19H26c-0.05-1.49-0.21-2.89-0.46-4.17
	c1.68-0.38,2.85-0.85,3.46-1.15C30.08,15.21,30.78,17.03,30.95,19z M27.65,12.1c-0.58,0.23-1.45,0.53-2.601,0.79
	c-0.39-1.29-0.89-2.41-1.49-3.3C25.11,10.12,26.5,10.98,27.65,12.1z M23.05,13.23c-0.899,0.12-1.91,0.19-3.03,0.19
	c-1.13,0-2.15-0.07-3.07-0.19c0.79-2.46,1.96-3.98,3.05-3.98S22.26,10.77,23.05,13.23z M20.02,15.42c1.3,0,2.48-0.09,3.53-0.24
	c0.24,1.15,0.4,2.44,0.45,3.82h-8c0.05-1.38,0.21-2.67,0.45-3.82C17.51,15.33,18.7,15.42,20.02,15.42z M16.44,9.59
	c-0.59,0.89-1.1,2-1.49,3.29c-1.15-0.25-2.02-0.55-2.59-0.78C13.51,10.98,14.9,10.12,16.44,9.59z M11.01,13.68
	c0.61,0.3,1.77,0.77,3.45,1.14C14.21,16.1,14.05,17.51,14,19H9.05C9.22,17.03,9.92,15.21,11.01,13.68z M9.05,21H14
	c0.05,1.49,0.21,2.89,0.46,4.17c-1.68,0.38-2.85,0.85-3.46,1.14C9.92,24.78,9.22,22.96,9.05,21z M12.36,27.9
	c0.58-0.23,1.45-0.53,2.59-0.79c0.39,1.29,0.89,2.409,1.49,3.3C14.9,29.88,13.51,29.02,12.36,27.9z M20,30.75
	c-1.09,0-2.26-1.52-3.05-3.98c0.9-0.119,1.91-0.189,3.03-0.189c1.13,0,2.15,0.07,3.07,0.189C22.26,29.23,21.09,30.75,20,30.75z
	 M19.98,24.58c-1.3,0-2.48,0.09-3.53,0.24c-0.24-1.15-0.4-2.44-0.45-3.82h8c-0.05,1.38-0.21,2.67-0.45,3.82
	C22.49,24.67,21.3,24.58,19.98,24.58z M23.56,30.41c0.591-0.891,1.101-2,1.49-3.29c1.15,0.25,2.03,0.55,2.601,0.78
	C26.5,29.02,25.11,29.88,23.56,30.41z M29,26.32c-0.61-0.29-1.78-0.771-3.46-1.141C25.79,23.9,25.95,22.49,26,21h4.95
	C30.78,22.97,30.08,24.79,29,26.32z"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Internet.jsx